import React from 'react'

const delays = [-0.45, -0.3, -0.15, 0]

const SimpleLoading = (props) => (
  <div style={style.wrapper} {...props}>
    <style>{style.animation}</style>
    <div style={style.ring}>
      {delays.map((delay, i) => (
        <div
          key={i}
          style={{
            ...style.div,
            animationDelay: `${delay}s`,
          }}
        />
      ))}
    </div>
  </div>
)

const style = {
  wrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  ring: {
    display: 'inline-block',
    position: 'relative',
    width: '32px',
    height: '32px',
    color: 'rgb(133, 133, 133)',
    opacity: 0.4,
  },
  div: {
    boxSizing: 'border-box',
    display: 'block',
    position: 'absolute',
    width: '26px',
    height: '26px',
    margin: '3px',
    border: '3px solid currentColor',
    borderRadius: '50%',
    borderColor: 'currentColor transparent transparent transparent',
    animation: 'lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite',
  },
  animation: `
    @keyframes lds-ring {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `,
}

export default SimpleLoading
